import { connect, useDispatch } from 'react-redux'
import PrescriptionForm from './PrescriptionForm'
import PrescriptionHeader from './PrescriptionHeader'
import PrescriptionActions from './PrescriptionActions'
import { reportCreate, reportEdit, reportReset, reportUpdate } from '../../../../redux/actions/reports/reportsActions'
import Alert from '../../../../itrust_common/components/Alert'
import * as $ from 'jquery';
import { quickActionsReset } from '../../../../redux/actions/dashboard/quickActionActions'
import { change, reset } from 'redux-form'

function Prescription(props) {
  const { prescription } = props
  const dispatch = useDispatch()

  const handlePrescriptionSubmit = async (data) => {
    if (data.id) {
      if (data.check_empty_prescription && !data.finalized_lenses_attributes.length && !data.finalized_glasses_attributes.length) {
        Alert.warning('Please select Finalized Lens or Finalized Glass.')
        dispatch(change('PrescriptionForm', 'check_empty_prescription', false))
        return ''
      }
      else {
        await dispatch(reportUpdate(data, { include: '*' }))
      }
    } else {
      await dispatch(reportCreate(data, { include: '*' }))
    }
    if (data.check_empty_prescription) {
      handleReset()
    }
  }

  const handleResetData = () => {
    dispatch(reportReset())
    dispatch(quickActionsReset())
    dispatch(reportEdit({ showPrescriptionModal: false }))
  }

  const handleReset = () => {
    setTimeout(() => {
      $('#prescription-modal').modal('hide');
      handleResetData()
      dispatch(reset('PrescriptionForm'));
    }, 700);
  }

  return (
    <div>
      <PrescriptionHeader />
      {prescription.id && <PrescriptionActions prescription={prescription} />}
      <PrescriptionForm onSubmit={handlePrescriptionSubmit} />
    </div>
  )
}

const mapStateToProps = (state) => {
  const { reports: { report } } = state;
  return {
    prescription: report,
  }
}

export default connect(mapStateToProps)(Prescription)